import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

const Patient = () => import('@/entities/patient/patient.vue');
const PatientUpdate = () => import('@/entities/patient/patient-update.vue');
const PatientDetails = () => import('@/entities/patient/patient-details.vue');

const Measurement = () => import('@/entities/measurement/measurement.vue');
const MeasurementUpdate = () => import('@/entities/measurement/measurement-update.vue');
const MeasurementDetails = () => import('@/entities/measurement/measurement-details.vue');

// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: 'patient',
      name: 'Patient',
      component: Patient,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'patient/new',
      name: 'PatientCreate',
      component: PatientUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'patient/:patientId/edit',
      name: 'PatientEdit',
      component: PatientUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'patient/:patientId/view',
      name: 'PatientView',
      component: PatientDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'measurement',
      name: 'Measurement',
      component: Measurement,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'measurement/new',
      name: 'MeasurementCreate',
      component: MeasurementUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'measurement/patient/:patientId',
      name: 'MeasurementsForPatient',
      component: Measurement,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'measurement/patient/:patientId/new',
      name: 'MeasurementCreateForPatient',
      component: MeasurementUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'measurement/:measurementId/edit',
      name: 'MeasurementEdit',
      component: MeasurementUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'measurement/:measurementId/view',
      name: 'MeasurementView',
      component: MeasurementDetails,
      meta: { authorities: [Authority.USER] },
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
};
